<template>
  <div style="width: 100%">
    <HeaderMenu :title="$t('general.dpiSetting')" routeBackName="tools" />

    <div class="container lang-dir">
      {{ $t("general.dpiSetting") }}
      <PdfDpiSlider />
    </div>
  </div>
</template>

<script>
import PdfDpiSlider from "@/components/book/PdfDpiSlider";

export default {
  props: ["title"],
  components: { PdfDpiSlider },
};
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  padding: 15px;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: 10px;
}
</style>
